module.exports = __webpack_public_path__ + "files/8055319e181b497fd99fbc53dd73357a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/audio.svg
// module id = 522
// module chunks = 27